var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbonnementIkon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54 48.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9615b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.77,15.57h-4.3v-.35c0-.54-.44-.98-.98-.98s-.98,.44-.98,.98v.35h-9.84v-.35c0-.54-.44-.98-.98-.98s-.98,.44-.98,.98v.35h-3.48c-.74,0-1.35,.6-1.35,1.35v16.46c0,.74,.6,1.35,1.35,1.35h21.53c.74,0,1.35-.6,1.35-1.35V16.92c0-.74-.6-1.35-1.35-1.35Zm-.62,5.78v11.41H16.85v-11.41h20.29Zm-16.45-2.76c.54,0,.98-.44,.98-.98v-.07h9.84v.07c0,.54,.44,.98,.98,.98s.98-.44,.98-.98v-.07h3.68v1.86H16.85v-1.86h2.86v.07c0,.54,.44,.98,.98,.98Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 17.82,
    y: 27.5,
    width: 3.82,
    height: 3.82,
    rx: 0.81,
    ry: 0.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.62,
    y: 27.5,
    width: 3.82,
    height: 3.82,
    rx: 0.81,
    ry: 0.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 22.62,
    y: 22.69,
    width: 3.82,
    height: 3.82,
    rx: 0.81,
    ry: 0.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.42,
    y: 27.5,
    width: 3.82,
    height: 3.82,
    rx: 0.81,
    ry: 0.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.42,
    y: 22.69,
    width: 3.82,
    height: 3.82,
    rx: 0.81,
    ry: 0.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.22,
    y: 27.5,
    width: 3.82,
    height: 3.82,
    rx: 0.81,
    ry: 0.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32.22,
    y: 22.69,
    width: 3.82,
    height: 3.82,
    rx: 0.81,
    ry: 0.81
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.7,28.53l-2.66-3.03c-.45-.51-1.22-.56-1.73-.11l-3.03,2.66c-.24,.21-.39,.52-.41,.84h0c-.07,1.09,1.21,1.72,2.03,1l.61-.54c-2.19,9.95-11.06,17.21-21.46,17.21-4.74,0-9.25-1.48-13.05-4.29-3.73-2.75-6.45-6.52-7.87-10.91-.22-.68-.99-1.03-1.66-.72-.56,.26-.81,.92-.62,1.5,1.58,4.84,4.59,9.01,8.71,12.05,4.22,3.12,9.22,4.76,14.48,4.76,11.78,0,21.8-8.4,23.96-19.8l.86,.98c.72,.82,2.07,.36,2.14-.73h0c.02-.32-.09-.64-.3-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.14,20.07h0c.07-1.09-1.21-1.72-2.03-1l-.61,.54C7.69,9.66,16.56,2.4,26.96,2.4c4.74,0,9.25,1.48,13.05,4.29,3.73,2.75,6.45,6.52,7.87,10.91,.22,.68,.99,1.03,1.66,.72,.56-.26,.81-.92,.62-1.5-1.58-4.84-4.59-9.01-8.71-12.05C37.23,1.65,32.22,0,26.96,0,15.18,0,5.17,8.4,3,19.8l-.86-.98c-.72-.82-2.07-.36-2.14,.73h0c-.02,.32,.09,.64,.3,.89l2.66,3.03c.45,.51,1.22,.56,1.73,.11l3.03-2.66c.24-.21,.39-.52,.41-.84Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbonnementIkon);
export default __webpack_public_path__ + "static/media/Abonnement_Ikon.200a3cd7bcb29d8898268332431d6dee.svg";
export { ForwardRef as ReactComponent };